module.exports = __webpack_public_path__ + "static/krakow-sky-run-58fcf3e6901e5700c4ab19e6db2dbfa8.mp4";